export const popupNav = () => {

	//Controls the hover effects for the popup navigation
	const mainNavLinks = document.querySelectorAll('.js__nav-link'); //Get all nav links
	
	if(mainNavLinks.length > 0){ //Make sure there actually are a few !
		mainNavLinks.forEach((navLink) => { //Loop through each and give each link an on hover listener
			navLink.addEventListener('mouseover', (event) => {
				var currentNavHoverIndex = event.target.dataset.item; //Store the index for the current nav item, so we can highlight the appropriate image
				if(currentNavHoverIndex){

					//Keep the nav item we're hovering visible, and reduce opacity on the other nav items (does require another loop though)
					mainNavLinks.forEach((loopNavLink) => {
						if(loopNavLink.dataset.item != currentNavHoverIndex){
							loopNavLink.classList.add('unfocus');
						}else{
							loopNavLink.classList.remove('unfocus');
						}
					})	
						
					//Display the linked image for this nav item
					var navImages = document.querySelectorAll('.main-nav__image');
					if(navImages){
						navImages.forEach((navImage) => {
							if(navImage.dataset.item == currentNavHoverIndex){
								navImage.classList.add('active');
							}else{
								navImage.classList.remove('active');
							}
						})
					}

				}else{ //Not hovering on nav item, make all visible
					mainNavLinks.forEach((loopNavLink) => {
						loopNavLink.classList.remove('unfocus');
					})	
				}
			});

			navLink.addEventListener('mouseleave', (event) => {
				mainNavLinks.forEach((loopNavLink) => {
					loopNavLink.classList.remove('unfocus');
				});
			});
		});
	}else{
		console.warn('No links found for main navigation.');
	}
}